import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { LanguageSwitcher } from '../components/language-switcher/language-switcher';

export const SharedLinkHeader = () => {
  const { t } = useTranslation();
  const logoAlt = t('header.logo.alt', { ns: 'navigation' });

  return (
    <Header>
      <HeaderLogo alt={logoAlt} src="/static/assets/img/navbar_logo.png" />
      <HeaderLanguageSwitcher>
        <LanguageSwitcher />
      </HeaderLanguageSwitcher>
    </Header>
  );
};

const Header = styled.header`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  background-color: var(--top-menu-background-color);
  box-shadow:
    0 1px 3px rgba(0, 0, 0, 0.12),
    0 1px 2px rgba(0, 0, 0, 0.24);
  z-index: 10000;
`;

const HeaderLogo = styled.img`
  grid-column: 2;
  height: 55px;
  margin: 0 50px 0 10px;
  padding: 10px 0;
`;

const HeaderLanguageSwitcher = styled.div`
  grid-column: 3;
  justify-self: end;
  padding-right: 12px;
`;
